import Vue from 'vue'
//https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
export default function () {
  const requireComponent = require.context(
    './'
  );

  requireComponent.keys().forEach(fileName => {
    if (!_.upperFirst(fileName) == fileName) return;
    const componentConfig = requireComponent(fileName);
    const componentName = _.upperFirst(
      _.camelCase(fileName.replace(/\.\w+$/, ''))
    );
    Vue.component(componentName, componentConfig.default || componentConfig);
  });
}



// WEBPACK FOOTER //
// ./src/action-items/types/autoload.js